import { UserSubscriptionTransaction } from "@/domain/entities/UserSubscriptionTransaction"
import { IUserSubscriptionHistoryRepository } from "@/domain/repositories/IUserSubscriptionHistoryRepository"
import { IListUserSubscriptionHistoryUseCase } from "@/domain/usecases/IListUserSubscriptionHistoryUseCase"

export class ListUserSubscriptionHistoryUseCase implements IListUserSubscriptionHistoryUseCase {
    repository: IUserSubscriptionHistoryRepository
    constructor(repository: IUserSubscriptionHistoryRepository) {
        this.repository = repository
    }

    execute(userId: string): Promise<UserSubscriptionTransaction[]> {
        return this.repository.list(userId)
    }
}
